import { LitElement, css, svg } from '~/lib/bn-lit-element';

class BnIconBin extends LitElement {
  static get styles() {
    return css`
      :host {
        display: inline-block;
        height: 100%;
      }
      svg path {
        transition: 0.2s fill;
        fill: var(--primary, red);
      }
    `;
  }

  render() {
    return svg`
      <svg
        version="1.1"
        height="100%"
        width="100%"
        viewBox="-7 -25 14 25"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M0,0 L-7,-9 L-7,-20 L0,-25 L7,-20 L7,-9 L0,0z" />
      </svg>
    `;
  }
}

window.customElements.define('bn-icon-bin', BnIconBin);
